/**
 * prerender's headless Chromium appends "Prerender (+https://github.com/prerender/prerender)"
 * to its User-Agent. Trackers should early-out on it: a render is not a visit,
 * and beacons that never settle keep the render open until prerender's
 * pageLoadTimeout (the reason Pendo/Stripe are also blocked server-side in
 * securspace-aws#20).
 */
export const isPrerenderUserAgent = (
  userAgent: string = typeof navigator !== 'undefined' ? navigator.userAgent : ''
): boolean => /\bPrerender\b/.test(userAgent);
